import { Component, computed, input } from '@angular/core';
import { ThemeColor, ThemeSize } from '../helpers';

@Component({
  selector: 'app-pan-spinner',
  templateUrl: './pan-spinner.component.html',
  styleUrl: './pan-spinner.component.scss',
  standalone: false,
})
export class PanSpinnerComponent {
  public color = input<ThemeColor>('default');
  public size = input<ThemeSize>('md');

  public classes = computed(() => {
    return ['spinner', `spinner-size-${this.size()}`, `spinner-color-${this.color()}`];
  });
}
